import React, { useState } from 'react';
import { bool, func, string, shape } from 'prop-types';

import { Overlay } from '@thd-olt-component-react/overlay';

import { StoreRow } from '../StoreRow/StoreRow';
import useRentalAvailability from '../../hooks/useRentalAvailability';

import './check-nearby-stores.scss';

export const CheckNearByStores = ({
  brandName,
  clientStore,
  imageUrl,
  opened,
  productLabel,
  rentalCategory,
  rentalSubCategory,
  storeZip,
  toggleOpened,
}) => {
  const [address, setAddress] = useState(storeZip);
  const [search, setSearch] = useState(address);

  const { stores, isLoading, isError } = useRentalAvailability({
    rentalCategory,
    rentalSubCategory,
    address
  });

  const handleSearchClick = (evt) => {
    evt.stopPropagation();
    setAddress(search);
  };

  const handleSearchInputChange = (evt) => {
    evt.stopPropagation();
    setSearch(evt.target.value);
  };

  const handleOverlayToggle = () => {
    toggleOpened(false);
  };

  return (
    <Overlay
      className="overlay"
      closeButton
      fit
      medium
      onClose={handleOverlayToggle}
      open={opened}
      positionedCloseButton
      scrollable={false}
    >
      <div className="overlay-container">
        <div className="title-bar">
          <img className="thumbnail" alt="thumbnail" src={imageUrl} height="85px" width="85" />
          <div className="title-container">
            <div className="title">{productLabel}</div>
            <div className="brand">by <span className="bold">{brandName}</span></div>
          </div>
        </div>
        <hr />
        <div className="search-bar-container">
          <div className="nearby-store-count-container">
            <div className="quantity">{stores?.length}</div>
            <div className="stores-near">Store(s) near {address}</div>
            <div className="carry-this">carry this tool</div>
          </div>
          <div className="search-box">
            <label htmlFor="search-bar" className="search-input">
              Zip Code, City, State, or Store #
              <span className="search-inline">
                <input
                  type="text"
                  className="search-bar"
                  data-testid="search-bar"
                  id="search-bar"
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  value={search}
                />
                <button
                  type="button"
                  className="search-button bttn-primary"
                  data-testid="search-button"
                  onClick={handleSearchClick}
                >
                  <span className="bttn__content">
                    <img
                      alt="magnifying glass"
                      data-testid="search-image"
                      src="https://assets.homedepot-static.com/images/v1/magnify-symbol-white.svg"
                      height="38px"
                      width="38px"
                    />
                  </span>
                </button>
              </span>
            </label>
          </div>
        </div>
        <div className="location-title-bar">
          <div className="location-text">
            This tool is available for rent today at the following locations:
          </div>
        </div>
        <hr />
        <div className="store-availability-container">
          { isLoading && (<div>Loading....</div>)}
          { isError && (<div>Not a valid address....</div>)}
          {stores && stores.length >= 0 && (stores.map((store, index) => (
            <StoreRow
              clientStore={clientStore}
              key={store.storeId}
              index={index}
              store={store}
              toggleOpened={toggleOpened}
            />
          )
          ))}
        </div>
      </div>
    </Overlay>
  );
};

CheckNearByStores.propTypes = {
  brandName: string.isRequired,
  clientStore: shape({}).isRequired,
  imageUrl: string.isRequired,
  opened: bool.isRequired,
  productLabel: string.isRequired,
  rentalCategory: string.isRequired,
  rentalSubCategory: string.isRequired,
  storeZip: string.isRequired,
  toggleOpened: func.isRequired
};